var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-field"},[_c('div',{staticClass:"ui-field_header"},[_c('span',{staticClass:"ui-field_label"},[_vm._v(_vm._s(_vm.label))]),_vm._t("headerAppend")],2),_c('div',{staticClass:"ui-field_control"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }